import { z } from 'zod';

import { fullNameSchema, transformFullNameSchema } from 'components/shared/types/FullNameSchema';

export const subAgentSchema = z
  .object({
    id: z.number(),
    phone: z.string(),
    email: z.string().nullable().optional(),
    crm_id: z.string().nullable().optional(),
    ...fullNameSchema.shape,
  })
  .transform((raw) => {
    return {
      id: raw.id,
      phone: raw.phone,
      email: raw.email,
      crmId: raw.crm_id,
      ...transformFullNameSchema.parse(raw),
    };
  });

export type SubAgentEntityApi = z.input<typeof subAgentSchema>;

export type SubAgentEntity = z.infer<typeof subAgentSchema>;
